<template>
  <img
    :src="currentSrc"
    v-bind="$attrs"
    alt=""
    @error="handleError"
    @load="handleLoad"
  />
</template>

<script>
export default {
  name: "RetryImage",
  props: {
    src: {
      type: String,
      required: true,
    },
    maxRetries: {
      type: Number,
      default: 5,
    },
    retryDelay: {
      type: Number,
      default: 1500,
    },
    placeholder: {
      type: String,
      default: "/img/placeholder.png",
    },
  },
  data() {
    return {
      retries: 0,
      currentSrc: "",
    };
  },
  watch: {
    src: {
      immediate: true,
      handler() {
        this.retries = 0;
        this.currentSrc = this.src;
      },
    },
  },
  methods: {
    handleError() {
      this.currentSrc = this.placeholder;
      if (this.retries < this.maxRetries) {
        this.retries++;
        setTimeout(() => {
          this.currentSrc = `${this.src}${
            this.src.includes("?") ? "&" : "?"
          }t=${Date.now()}`;
        }, this.retryDelay);
      }
    },
    handleLoad() {
      this.$emit("loaded");
    },
  },
};
</script>
